// extracted by mini-css-extract-plugin
export default {"container":"mN-z","title":"nN-z","link":"oN-z"};